import React from "react";
import withSizePositionAngle from "components/withSizePositionAngle";


const _Gras = () => {
    return (
        <g>
          <path fill="#47bc34" fillOpacity="1" stroke="#60b652" strokeWidth="4.27684" strokeLinecap="round" strokeLinejoin="miter" strokeMiterlimit="4" strokeDasharray="none" strokeDashoffset="0" strokeOpacity="1" stopColor="#000000" d="m0,115.64c305.6,0 547.75,-115.64 1157.54,-115.64c1935.02,0 2179.84,115.64 2683.18,115.64l0,99.13l-3840.72,0l0,-99.13z" />
        </g>
    );
}

const Gras = withSizePositionAngle(_Gras, 3840.723040, 214.774200);

export default Gras;
